/* ====== START: Browser API ====== */
export const POSITION_ERROR_CODES = {
  PERMISSION_DENIED: 1,
  POSITION_UNAVAILABLE: 2,
  TIMEOUT: 3,
};

/* ====== END: Browser API ====== */

/* ====== START: Error messages ====== */
export const ERROR_MESSAGES = {
  CHECKOUT_SESSION_EXPIRED: 'Your session has expired. Please retry the checkout process with your service provider.',
  LOCATION_PERMISSIONS_ERRORED: 'An error occurred while retrieving your location.',
  LOCATION_PERMISSIONS_DENIED: 'Your browser or device does not have location access enabled for this site.',
  LOCATION_PERMISSIONS_POSITION_UNAVAILABLE: 'We could not determine your current location.',
  LOCATION_PERMISSIONS_TIMEOUT: 'It took too long to retrieve your current location.',
  SELF_CHECKOUT_SESSION_INITIALIZE:
    'An unexpected error occurred while initializing your checkout session. Please retry the checkout process with your service provider.',
};

/* ====== END: Error messages ====== */

/* ====== START: Checkout ====== */
export const APPROVE_TYPES = {
  CLAIM_AND_PAYMENT: 'claim-and-payment',
  PAYMENT_ONLY: 'payment-only',
};

/* ====== END: Checkout ====== */

/* ====== START: UI payment actions ====== */
export const TRANSACTION_ACTIONS = {
  APPROVED: 'approved',
  EXPIRED: 'expired',
  FAILURE: 'failure',
  REJECTED: 'rejected',
};

/* ====== END: UI payment actions ====== */

/* ====== START: UI breakpoints ====== */
export const SMALL_MOBILE_MAX_BREAKPOINT = 320;
export const TOUCH_MAX_BREAKPOINT = 1024;

/* ====== END: UI breakpoints ====== */

/* ====== START: URLs ====== */
export const AUTH_URL = '/account/login/';
export const AUTH_URL_FORCE_LOGIN = '/account/login/?showLogin=true';
export const EXPIRED_CHECKOUT_URL = '/checkout/expired/';
export const EXPIRED_PAYMENTMETHODS_URL = '/paymentmethods/expired';
/* ====== END: URLs ====== */

/* ====== START: TYRO HEALTH URLs ====== */
export const THO_URL = 'https://www.tyrohealth.com/';
export const THO_TERMS_AND_CONDITION_URL = 'https://www.tyrohealth.com/terms-conditions/';
export const THO_PRIVACY_POLICY_URL = 'https://www.tyrohealth.com/privacy/';
export const THO_HELP_CENTRE_URL = 'https://help.tyrohealth.com/en/';
/* ====== END: TYRO HEALTH URLs ====== */
